<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<template>
  <slot />
</template>
